import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable, ReplaySubject, Subject} from 'rxjs';
import {GlobalSearchResultItem} from "../models/global-search.model";

@Injectable({
  providedIn: 'root'
})
export class GlobalSearchHistoryService {
  private readonly MAX_HISTORY = 10;
  private readonly STORAGE_KEY = 'global_search_history';
  private globalSearchHistory: string[] = [];

  globalSearchHistorySubject = new BehaviorSubject<GlobalSearchResultItem[]>([]);
  globalSearchHistory$: Observable<GlobalSearchResultItem[]> = this.globalSearchHistorySubject.asObservable();

  constructor() {
    this.initializeGlobalSearchHistory();
  }

  private initializeGlobalSearchHistory(): void {
    const storedHistory = sessionStorage.getItem(this.STORAGE_KEY);
    if (storedHistory) {
      this.globalSearchHistorySubject.next(JSON.parse(storedHistory));
    }
  }

  public addGlobalSearch(globalSearch: GlobalSearchResultItem): void {
    // Don't add the same globalSearch twice in a row
    const currentGlobalSearchHistory = this.globalSearchHistorySubject.value;
    if (currentGlobalSearchHistory.find(sh => sh.id === globalSearch.id && sh.searchType === globalSearch.searchType)){
      return;
    }

    currentGlobalSearchHistory.unshift(globalSearch);

    // Keep only the last MAX_HISTORY globalSearchs
    if (currentGlobalSearchHistory.length > this.MAX_HISTORY) {
      currentGlobalSearchHistory.pop();
    }

    // Update session storage
    sessionStorage.setItem(this.STORAGE_KEY, JSON.stringify(currentGlobalSearchHistory));

    // Update the current globalSearch subject
    this.globalSearchHistorySubject.next(currentGlobalSearchHistory);
  }

}
